<template>
  <hic-list-page v-if="permission.datacenter_data_query" title="数据库链接列表" :entities="entities" :condition="condition" @load="page" keyword-placeholder="请输入名称或编码" :loading="meta.loading">
    <template slot="buttons">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="create">新建</el-button>
    </template>
    <el-table-column v-if="permission.datacenter_setting_db" align="center" label="操作" width="150" key="iousCmd">
      <template slot-scope="{ row }">
        <el-button type="primary" title="编辑" size="mini" icon="el-icon-edit" circle plain @click="edit(row)"></el-button>
        <el-button type="danger" title="删除" size="mini" icon="el-icon-delete" circle plain @click="del(row)"></el-button>
        <el-button type="warning" title="复制" size="mini" icon="el-icon-document-copy" circle plain @click="copy(row)"></el-button>
      </template>
    </el-table-column>
    <el-table-column align="left" label="名称" prop="name" width="300" sortable="custom">
      <template #default="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column align="left" label="编码" prop="code" width="200" sortable="custom"></el-table-column>
    <el-table-column align="left" label="类型" prop="" :filters="dictEnum.DataBaseType" :filter-multiple="false" column-key="type" sortable="custom">
      <template #default="{ row }">
        <el-tag v-if="row.type == 'SqlServer'" type="success" hit size="small">{{ row.type }}</el-tag>
        <el-tag v-if="row.type == 'PostgreSQL'" type="primary" hit size="small">{{ row.type }}</el-tag>
        <el-tag v-if="row.type == 'MySql'" type="warning" hit size="small">{{ row.type }}</el-tag>
        <el-tag v-if="row.type == 'Oracle'" type="danger" hit size="small">{{ row.type }}</el-tag>
      </template>
    </el-table-column>

    <Editor v-model="entity" :visible.sync="meta.showEditor" @close="page"></Editor>
  </hic-list-page>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      Editor: () => import("./edit"),
    },
    data() {
      return {
        meta: {
          showEditor: false,
          loading: false,
        },
        condition: {
          keyword: null,
          sort: "id",
          asc: false,
          pageSize: 20,
          pageIndexOnViewer: 1,
        },
        entities: {},
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
    },
    methods: {
      page() {
        this.meta.loading = true;
        try {
          api.DbCon.query(this.condition)
            .then((res) => {
              this.entities = res;
            })
            .catch((err) => {
              this.$message.error(err.message || err);
            })
            .finally(() => {
              this.meta.loading = false;
            });
        } catch (err) {
          if (err && err != "cancel") {
            console.log(err);
            this.$message.error(err.message || err);
          }
        }
      },
      create() {
        this.$set(this, "entity", {});
        this.meta.showEditor = true;
      },
      edit(row) {
        this.entity = this.$utils.Obj.clone(row);
        this.meta.showEditor = true;
      },
      del(row) {
        this.$confirm("确定要删除？", "确认", { type: "warning" })
          .then(() => {
            this.meta.loading = true;
            api.DbCon.del(row.id)
              .then((res) => {
                this.$store.dispatch("loaders", "DataLink");
                this.page();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          })
          .catch((e) => {});
      },
      copy(row) {
        this.entity = this.$utils.Obj.clone(row);
        delete this.entity.id;
        this.meta.showEditor = true;
      },
    },
  };
</script>
